import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Box, Typography, List, ListItem, ListItemText } from "@mui/material";

const SearchResultsPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const searchResults = location.state?.results || [];

  return (
    <Box sx={{ paddingTop: "60px", paddingX: 2 }}>
      <Typography
        variant="h5"
        gutterBottom
        sx={{
          color: "#1976d2",
          display: "inline-block",
          marginBottom: 2,
          fontWeight: 600,
        }}
      >
        Search Results
      </Typography>

      {searchResults.length > 0 ? (
        <List>
          {searchResults.map((result, index) => (
            <ListItem
              key={index}
              button
              onClick={() => {
                navigate(
                  `/Modules/Course/${result.courseId}/Module/${result.moduleId}/Chapter/${result.chapter}/Lesson/${result.lessonId}`,
                  {
                    state: {
                      lessonName: result.lessonName,
                      moduleName: result.moduleName,
                      courseName: result.courseName,
                    },
                  }
                );
              }}
              sx={{
                "&:hover": {
                  backgroundColor: "#f5f5f5",
                },
              }}
            >
              <ListItemText
                primary={
                  <Typography
                    sx={{
                      color: "#1976d2",
                      textDecoration: "underline",
                      cursor: "pointer",
                    }}
                  >
                    {result.lessonName}
                  </Typography>
                }
                secondary={`${result.moduleName} - ${result.chapter}`}
              />
            </ListItem>
          ))}
        </List>
      ) : (
        <Typography>No results found.</Typography>
      )}
    </Box>
  );
};

export default SearchResultsPage;
